import React from 'react'
import { FiInfo, FiSettings } from "react-icons/fi"
import { Formik } from "formik";
import Navbar from '../../../@shared/navigations/default';
import { optsTabs, skillList } from './mock';
import {Versioning} from './versioning'
import {Skills} from './skills'
import {Langs} from './langs'
import {Requests} from './requests'
import {Featuring} from './featuring'
import {Switcher} from '../../../@shared/elements/switcher'
import { UploadImages } from './preview';

const ProjectCreatePage = () => {
    let project = {}
    let mode = true 
    
    const [tab, setTab] = React.useState('project-create')
    React.useEffect(() => {
        const bodyTag = document.getElementsByTagName('html')[0];
            bodyTag.classList.remove('stop')
    }, []);
    const [gallery] = React.useState([])
    const [privacy, setPrivacy] = React.useState(project?.privacy)

    const resetForm = () => {}

    return  <React.Fragment>
        <title>Create Project</title>
        <Navbar />
        <Formik
            initialValues={{
                title: project?.title,
                desc: project?.desc,
            }}
            onSubmit={(values, { setSubmitting }) => {
                setTimeout(() => {
                    setSubmitting(false);
                }, 100);
            }}
        >
            {({
                values, errors, touched, handleChange, handleBlur, setFieldValue, handleSubmit, isSubmitting,
            }) => (
                <form onSubmit={handleSubmit}>
                    <div className="container5">
                        <div>
                            <div className="">
                                <div className="relative"></div>
                                <div className="options_component opt_sticky">
                                    <div className="heading">
                                        <h3 className="title">{mode ? 'Edit Project' : 'Create Project'}</h3>
                                        <h4 className="title"> <FiSettings /> </h4>
                                    </div>
                                    <ul>
                                        {optsTabs.map((item, i) => {
                                            return (
                                                <li key={'opt' + i}>
                                                    <a href="##" className={`${item.type === tab && 'active'}`} onClick={() => setTab(item.type)} >
                                                        <div className="symbol">{item.symbol}</div>
                                                        <div>{item.title}</div>
                                                    </a>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>

                            </div>
                            <div>
                                <div className={` ${tab !== 'project-create' && 'hidden'}`}>
                                    <div className="">

                                        {true && (
                                            <Versioning
                                                title={`${project?.title} ${project?.code && '#' + project?.code}`}
                                                desc={project?.desc}
                                                ok={project?._id ? true : false}
                                            />
                                        )}

                                        <div className="create-page">
                                            <div className="row">
                                                <div className="col-6">
                                                    <label htmlFor="">Project title</label>
                                                    <input type="text"
                                                        name="title"
                                                        placeholder="Project title"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.title}
                                                    />
                                                </div>
                                                <div className="col-6">


                                                </div>
                                                <div className="col-12">
                                                    <div className="form-group">
                                                        <label htmlFor="">Description</label>
                                                        <textarea
                                                            name="desc"
                                                            placeholder="Project detail"
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.desc}
                                                        >{values.desc}</textarea>

                                                        <small className="">Explain your project min 500 character</small>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="flex">
                                                        <div></div>
                                                        <div className="flex">
                                                            <Switcher check={privacy} setCheck={setPrivacy} /> &nbsp;
                                                            <small className="tooltip-info">
                                                                {privacy ? 'Public' : 'Private'} Project <FiInfo size={23} /> <div> Not list in search. </div>
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>



                                                <div className="col-12">
                                                    <div className="flex-end">
                                                        {mode && (
                                                            <div className="reset mr-2" onClick={() => resetForm()} >
                                                                Reset
                                                            </div>
                                                        )}
                                                        <button type="submit" className="float-right btn btn-primary col-3"  >
                                                            {project?._id ? 'Update' : 'Create'}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                       
                                    <div className="create-page profile_component">
                                        <Featuring type="exp" name="Experiences" />
                                    </div>
                                    <div className="create-page profile_component">
                                        <Skills setFieldValue={setFieldValue} title="Skills" data={skillList} />
                                    </div>
                                    <div className="create-page profile_component">
                                        <Langs />
                                    </div>

                                        <div className="create-page">
                                            <UploadImages
                                                images={gallery}
                                                source={undefined}
                                            />


                                        </div>


                                    </div>
                                </div>
                                <div className={` ${tab !== 'media' && 'hidden'}`}>
                                    
                                    <div className="create-page">
                                            <UploadImages
                                                images={gallery}
                                                source={undefined}
                                            />
                                        </div>

                                </div>
                                <div className={` ${tab !== 'inbox' && 'hidden'}`}>
                                    <Requests team={project?.team} projectId={project?._id} />
                                    <div className="create-page profile_component">
                                        <Featuring type="exp" name="Experiences" />
                                    </div>
                                    <div className="create-page profile_component">
                                        <Skills setFieldValue={setFieldValue} title="Skills" data={skillList} />
                                    </div>
                                    <div className="create-page profile_component">
                                        <Langs />
                                    </div>
                                    
                                </div>

                            </div>
                        </div>
                    </div>
                </form>
            )}
        </Formik>
    </React.Fragment> 
}

export default ProjectCreatePage;



